import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

/**
 * Public landing for OLD therapist-issued invite links — program SUNSET
 * (CANON block 2, R4-C/R4-G): clinicians never pay for SonSpeak, referral
 * discounts and purchased sponsored-pass quotas no longer exist. Families
 * who already redeemed a sponsored pass keep it (honored server-side).
 * This page stays mounted so old shared links land somewhere honest.
 */
export default function InviteRedeem() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 dotted-bg" data-testid="invite-page">
      <div className="brutal-card bg-white p-6 sm:p-8 max-w-xl w-full">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-12 h-12 rounded-2xl border-[3px] border-[color:var(--ink)] bg-[color:var(--coral)] flex items-center justify-center text-white">
            <Heart size={22} />
          </span>
          <div>
            <div className="display text-xs uppercase tracking-[0.25em] text-[color:var(--ink-soft)] font-bold">
              About this invite link
            </div>
            <h1 className="display text-2xl sm:text-3xl font-extrabold leading-tight">
              This invite program has ended
            </h1>
          </div>
        </div>

        <p className="text-sm text-[color:var(--ink-soft)] leading-relaxed mb-3" data-testid="invite-sunset-copy">
          Clinician invite offers are no longer part of SonSpeak — clinicians
          never pay for SonSpeak, and there are no discount codes to claim.
          If your family already received a sponsored year, it&apos;s still
          honored on your account.
        </p>
        <p className="text-sm text-[color:var(--ink-soft)] leading-relaxed mb-5">
          You can still create an account in early access — no payment today.
          Families who need supported access can reach us directly at{" "}
          <a className="underline" href="mailto:hello@sonspeak.com">hello@sonspeak.com</a>.
        </p>

        <div className="grid sm:grid-cols-2 gap-2">
          <Link to="/register" className="pill-btn primary justify-center text-base py-3" data-testid="invite-register">
            Create account <ArrowRight size={16} />
          </Link>
          <Link to="/" className="pill-btn justify-center text-base py-3" data-testid="invite-home">
            Go to homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
